<script setup>
defineProps(['model'])
</script>

<template>
  <div class="container-fluid">
    <div class="author-profile prose block-spacing">
      <NuxtImg
        v-if="model?.aprimoAuthorImage?.url"
        provider="fastlyAprimo"
        :src="model.aprimoAuthorImage.url"
        class="author-profile__image"
        :alt="model.authorImageAltText?.value ? model.authorImageAltText.value : model.aprimoAuthorImage.altText"
        loading="lazy"
        :width="model.aprimoAuthorImage.width ?? 150"
      />
      <div class="h3 mt-0">
        About the Author
      </div>
      <p>
        {{ model.description.value }}
      </p>
    </div>
  </div>
</template>
